export default __webpack_public_path__ + "static/media/abhishek.92990c08.png";